import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import messages from '../../messagesOuigoRefunds';
import inlineStyles, {
	EmptyStateDescription,
	EmptyStateTitle,
	InlineSpinner,
} from './styles';

const SKELETON_ROWS = 5;

const skeletonWidths = {
	supplyChannelRecordLocator: 169,
	bookingLocator: 98,
	voucherNumber: 98,
	issueDate: 98,
	value: 98,
	selection: 16,
};

const tableStateMessages = {
	empty: {
		title: messages.lblNoVouchersFound,
		description: messages.lblNoVouchersFoundDescription,
	},
	error: {
		title: messages.lblUnableToLoadVouchers,
		description: messages.lblUnableToLoadVouchersDescription,
	},
};

const VouchersTableState = ({ columns, type }) => {
	const { formatMessage } = useIntl();

	if (type === 'loadingSpinner') {
		return (
			<div style={inlineStyles.loadingOverlay}>
				<InlineSpinner label={formatMessage(messages.lblFetchingVouchers)} />
			</div>
		);
	}

	if (type === 'loadingRows') {
		return Array.from({ length: SKELETON_ROWS }, (_, rowNumber) => (
			<TableRow
				key={`voucher-loading-row-${rowNumber + 1}`}
				style={inlineStyles.bodyRow}
			>
				{columns.map((column, columnIndex) => {
					const isFirstCell = columnIndex === 0;
					const isLastCell = columnIndex === columns.length - 1;
					const cellStyle = {
						...inlineStyles.rowCellBase,
						...(isFirstCell ? inlineStyles.firstRowCell : {}),
						...(isLastCell ? inlineStyles.lastRowCell : {}),
					};

					return (
						<TableCell key={column.key} style={cellStyle}>
							<div
								aria-hidden="true"
								style={{
									...inlineStyles.skeletonBlock,
									width: skeletonWidths[column.key],
								}}
							/>
						</TableCell>
					);
				})}
			</TableRow>
		));
	}

	const stateMessage = tableStateMessages[type];

	return (
		<TableRow>
			<TableCell colSpan={columns.length} style={inlineStyles.emptyCell}>
				<div style={inlineStyles.emptyStateWrapper}>
					<div style={inlineStyles.emptyState}>
						<EmptyStateTitle>
							<FormattedMessage {...stateMessage.title} />
						</EmptyStateTitle>
						<EmptyStateDescription>
							<FormattedMessage {...stateMessage.description} />
						</EmptyStateDescription>
					</div>
				</div>
			</TableCell>
		</TableRow>
	);
};

VouchersTableState.propTypes = {
	columns: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
		}),
	).isRequired,
	type: PropTypes.oneOf(['empty', 'error', 'loadingRows', 'loadingSpinner'])
		.isRequired,
};

export default VouchersTableState;
